import { render } from "./RebateForm.vue?vue&type=template&id=561795d4&scoped=true"
import script from "./RebateForm.vue?vue&type=script&lang=js"
export * from "./RebateForm.vue?vue&type=script&lang=js"

import "./RebateForm.vue?vue&type=style&index=0&id=561795d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561795d4"]])

export default __exports__